import type { Schema } from '../../../../../types/DirectusSchema';
import { removeUndefinedValues } from '../../../lib/removeUndefinedValues.ts';
import { mapTagsToTargetAudiences } from '../../incompleteEvent/formToApi/lib/mapTagsToTargetAudiences.ts';
import { parseIsoDate } from '../../incompleteEvent/formToApi/lib/parseIsoDate.ts';
import { parseFormValue } from '../../lib/parseFormValue.ts';
import type { FormData } from '../types/FormData.ts';

export const formToApi = (updateData: Partial<FormData>): Partial<Schema['events'][0]> => {
  const target_audiences = mapTagsToTargetAudiences(updateData.tags);

  const data = {
    name: parseFormValue(updateData.name) ?? undefined,
    category: updateData.category ? Number.parseInt(updateData.category, 10) : undefined,
    target_audiences,
    short_description: parseFormValue(updateData.shortDescription) ?? undefined,
    long_description: parseFormValue(updateData.longDescription),
    website_link: parseFormValue(updateData.websiteLink),
    start: parseIsoDate(updateData.start),
    end: parseIsoDate(updateData.end),
    ticket_sale_url: parseFormValue(updateData.ticketshopLink),
  };

  return removeUndefinedValues(data) as Partial<Schema['events'][0]>;
};
